import React from 'react'
import {
  StyledPopupContentWrapper,
  StyledSubtitle,
  StyledFooter,
  StyledStepContainer,
  StyledStep,
  StyledStepText,
  StyledH2,
} from './InstallationQuotesPopupContentWmo.css'

const InstallationQuotesPopupContentWmo = () => (
  <StyledPopupContentWrapper>
    <StyledSubtitle>
      Helping you save time doesn’t stop at connecting you with the parts you need.
      We’re proud to work with independent shops and merchants who are ready to help in your area.
    </StyledSubtitle>

    <StyledH2>How to Sign Up</StyledH2>

    <StyledStepContainer>
      <StyledStep>Step&nbsp;1:</StyledStep>
      <StyledStepText>
        Select “Yes! Email me free quotes to install my new part(s)
        at a local repair shop” during checkout
      </StyledStepText>
    </StyledStepContainer>

    <StyledStepContainer>
      <StyledStep>Step&nbsp;2:</StyledStep>
      <StyledStepText>
        Our dedicated team, will gather quotes from certified shops in your
        area and set up an appointment with the mechanic of your choice
      </StyledStepText>
    </StyledStepContainer>

    <StyledStepContainer>
      <StyledStep>Step&nbsp;3:</StyledStep>
      <StyledStepText>
        Show up at your schedules time with the part you ordered. That’s it!
      </StyledStepText>
    </StyledStepContainer>
    <StyledFooter>At CarParts.com, we’re committed to our customers’ privacy and will keep your personal information safe.</StyledFooter>
  </StyledPopupContentWrapper>
)

export default InstallationQuotesPopupContentWmo
